<div  class="kbacard kbacard__{{kbaStatus === 'Passed'? 'passed': 'failed'}}" >
  <div class="state-icon-container">
    @if (kbaStatus === 'Passed') {
      <img
        src="../../../assets/icons/check_circle-icon.svg"
        alt="green check circle"
        />
    }
    @if (kbaStatus === 'Failed') {
      <img
        src="../../../assets/icons/error-icon.svg"
        alt="error exclaimation mark"
        />
    }
  </div>
  <div class="card-body">
    <div class="status-result" data-private>KBA Status: {{ kbaStatus }}</div>
  </div>
</div>
